import Guider from './src/guider.vue';
import { SFCWithInstall } from '@touchvue/utils';
export declare const ToGuider: SFCWithInstall<typeof Guider>;
export default ToGuider;
export * from './src/instance';
